import { render, staticRenderFns } from "./LazyClientShow.vue?vue&type=template&id=73004e86&"
import script from "./LazyClientShow.vue?vue&type=script&lang=ts&"
export * from "./LazyClientShow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports